import { useTranslation } from 'react-i18next';
import { useSessionStore } from '../state/session-store.js';
import { useSettingsStore } from '../state/settings.js';

/** "E: Open calendar" next to an interactive object, and why the last try was refused (spec §6.6). */
export function InteractionPrompt() {
  const { t } = useTranslation();
  const target = useSessionStore((s) => s.interactionTarget);
  const notice = useSessionStore((s) => s.interactionNotice);
  const key = useSettingsStore((s) => s.keys.interact.label);
  if (!target) return null;
  return (
    <div className="hud-box interaction-prompt" role="status" aria-live="polite">
      <kbd>{key}</kbd> {t(target.labelKey)}
      {notice && <span className="interaction-notice">{t(`interact.rejected.${notice}`)}</span>}
    </div>
  );
}
